export default class MainMenu  {
  constructor() {
    this.$menuItems = document.querySelectorAll('.js-main-menu .c-main-menu__list > .menu-item');
    this.$header = document.querySelector('.js-header');

    this.$menuItems.forEach($item => {
      const $subMenu = $item.querySelector('.sub-menu');

      if ($subMenu) {
        $item.addEventListener('mouseover', () => {
          this.$header.classList.add('is-hovered');

          if ($subMenu) {
            $subMenu.classList.add('is-visible')
          }
        });

        $item.addEventListener('mouseleave', () => {
          this.$header.classList.remove('is-hovered');
          if ($subMenu) {
            $subMenu.classList.remove('is-visible')
          }
        });
      }
    })
  }
}